import ScrollOut from "scroll-out";

function setScrollOut(){

  ScrollOut({
    targets: "body",
    offset: window.screen.height
  });
  ScrollOut({
    targets: ".site-header__wrap, "+
             ".mobile-header__wrap"
  });
  ScrollOut({
    targets: ".section-wrap",
    offset: 550,
    onShown: function(el) {
      const current = document.getElementById('main');
      current.classList.add('has-background-white');
    },
    onHidden: function(el) {
      const current = document.getElementById('main');
      if(current.classList.contains('has-background-white')) current.classList.remove('has-background-white');
    }
  });
  ScrollOut({
    targets: ".site-footer__info-list",
    onShown: function(el) {
      const current = document.getElementsByClassName('site-header__wrap')[0];
      current.classList.add('hide-header');
      const currentMobile = document.getElementsByClassName('mobile-header__wrap')[0];
      currentMobile.classList.add('hide-header');
    },
    onHidden: function(el) {
      const current = document.getElementsByClassName('site-header__wrap')[0];
      if(current.classList.contains('hide-header')) current.classList.remove('hide-header');
      const currentMobile = document.getElementsByClassName('mobile-header__wrap')[0];
      if(currentMobile.classList.contains('hide-header')) currentMobile.classList.remove('hide-header');
    }
  });

}
setScrollOut();
